module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Ações e Proprietário")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Ações e Proprietário',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('form', {
    staticClass: "ng-pristine ng-invalid ng-invalid-required",
    attrs: {
      "name": "authForm"
    }
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "control-label col-sm-1"
  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('profiles', {
    attrs: {
      "disabled": true,
      "propsProfile": _vm.profile
    },
    on: {
      "profileSelected": function($event) {
        _vm.profile = _vm.profile
      }
    },
    model: {
      value: (_vm.profile),
      callback: function($$v) {
        _vm.profile = $$v
      },
      expression: "profile"
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._l((_vm.auths), function(item, index) {
    return _c('div', {
      staticClass: "col-lg-6 col-md-2 col-sm-12"
    }, [_c('div', {
      staticClass: "box box-default box-solid"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('h3', {
      staticClass: "box-title ng-binding"
    }, [_vm._v(_vm._s(_vm.$t('authority.register.' + index)))]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('label', {
      staticClass: "checkbox-inline new-control new-control-checkbox",
      staticStyle: {
        "margin-top": "-20px"
      }
    }, [_c('input', {
      staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
      attrs: {
        "disabled": true,
        "type": "checkbox",
        "name": "selectAll",
        "ng-model": "selectAll",
        "ng-change": "change(item, selectAll)"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "new-control-indicator"
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "box-body permission-list"
    }, _vm._l((item), function(authority) {
      return _c('div', {
        staticClass: "ng-scope"
      }, [_c('div', {
        staticClass: "checkbox-inline col-md-6 col-sm-12"
      }, [_c('label', {
        staticClass: "checkbox-inline new-control new-control-checkbox ng-binding"
      }, [_c('input', {
        staticClass: "ng-pristine ng-untouched ng-valid ng-empty",
        attrs: {
          "disabled": true,
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.verifica(authority.name)
        },
        on: {
          "change": function($event) {
            return _vm.adiciona(authority)
          }
        }
      }), _vm._v(_vm._s(_vm.$t('authority.register.' + authority.name)) + "\n                              "), _c('div', {
        staticClass: "new-control-indicator"
      })])])])
    }), 0)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('fieldset', [_c('div', {}, [_c('div', {
    staticClass: "col-sm-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "disabled": _vm.show.userForm || Object.keys(this.profile).length < 1 || _vm.profile.authorities.some(function (o) { return o.name === 'perfil-admin'; })
    },
    on: {
      "click": function($event) {
        _vm.show.userForm = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atribuir")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show.userForm),
      expression: "show.userForm"
    }],
    staticClass: "form-horizontal well well-sm no-shadow",
    attrs: {
      "name": "formUsuario"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('usuarios')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "usersProfile"
    }
  }, [_vm._v("Usuários:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group borda",
    class: {
      'has-error': _vm.errors.first('usuarios')
    }
  }, [_c('multiselect', {
    attrs: {
      "name": "usuarios",
      "options": _vm.usuariosPesquisa,
      "close-on-select": true,
      "hide-selected": true,
      "preserve-search": false,
      "placeholder": "Escolha um usuário",
      "label": "userName",
      "track-by": "userName",
      "preselect-first": true
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function(props) {
        return [_c('span', {
          staticClass: "custom__tag"
        }, [_c('span', [_vm._v(_vm._s(props.option.userName))]), _c('span', {
          staticClass: "custom__remove",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return props.remove(props.option)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.usersAdicionar),
      callback: function($$v) {
        _vm.usersAdicionar = $$v
      },
      expression: "usersAdicionar"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('usuarios')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('dataInicial')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "dataInicial"
    }
  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "dataInicial",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.profileConstraint.initialDate),
      callback: function($$v) {
        _vm.$set(_vm.profileConstraint, "initialDate", $$v)
      },
      expression: "profileConstraint.initialDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dataInicial')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "dt_inicial"
    }
  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "inactivateDate",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.profileConstraint.inactivateDate),
      callback: function($$v) {
        _vm.$set(_vm.profileConstraint, "inactivateDate", $$v)
      },
      expression: "profileConstraint.inactivateDate"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-2 ng-binding"
  }, [_c('span', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.adicionaUsuario($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-default btn-flat",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCancelUserToProfile($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.bordered,
      "items": _vm.users,
      "hover": _vm.hover,
      "fields": _vm.fields,
      "filter": _vm.filter,
      "current-page": _vm.currentPage,
      "per-page": 5,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "active",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "updatedAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": _vm.profile.name === 'Administrador',
            "to": {
              name: 'cadastro-usuarios-altera',
              params: {
                id: row.item.user.id
              }
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": _vm.profile.name === 'Administrador'
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteUser(row.item.user.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Permissões de Gerência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', [_vm._v("Usuários com estas permissões")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf626e28!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/acoes/ListaAcoes.vue
// module id = 2075
// module chunks = 1